import '../style/number-Dng1bo6v.css'
import { defineComponent as u, computed as p, openBlock as o, createElementBlock as s, createBlock as _, unref as d, createCommentVNode as t, toDisplayString as r, createElementVNode as f } from "vue";
import { divide as y, formatNumber as h } from "x-utils";
import k from "./coin.js";
const b = { class: "e-number" }, x = {
  key: 1,
  class: "e-number__text"
}, v = {
  key: 2,
  class: "e-number__dim-text"
}, B = { class: "e-number__text" }, g = {
  key: 3,
  class: "e-number__text"
}, z = {
  key: 4,
  class: "e-number__text"
}, M = {
  key: 5,
  class: "e-number__text"
}, S = /* @__PURE__ */ u({
  name: "e-number",
  __name: "number",
  props: {
    value: {},
    comma: { type: Boolean, default: !0 },
    precision: {},
    rounding: {},
    locale: {},
    currency: {},
    mask: { type: Boolean },
    prefix: {},
    suffix: {},
    showIcon: { type: Boolean },
    iconSize: {},
    iconTheme: {},
    dimming: { type: Boolean },
    millionMark: { type: Boolean }
  },
  setup(m) {
    const e = m, a = p(() => {
      let n = e.value;
      e.millionMark && (n = y(n, 1e6));
      const i = h(n, {
        comma: e.comma,
        precision: e.precision,
        rounding: e.rounding,
        locale: e.locale,
        mask: e.mask
      });
      if (e.dimming) {
        const c = i.split("").findIndex((l) => l.match(/[1-9]/));
        return [i.slice(0, c), i.slice(c)];
      } else
        return ["", i];
    });
    return (n, i) => (o(), s("span", b, [
      n.showIcon ? (o(), _(d(k), {
        key: 0,
        class: "e-number__icon",
        coin: n.currency,
        "show-name": !1,
        size: n.iconSize,
        theme: n.iconTheme
      }, null, 8, ["coin", "size", "theme"])) : t("", !0),
      e.prefix ? (o(), s("span", x, r(e.prefix), 1)) : t("", !0),
      n.dimming ? (o(), s("span", v, r(a.value[0]), 1)) : t("", !0),
      f("span", B, r(a.value[1]), 1),
      n.millionMark ? (o(), s("span", g, "M")) : t("", !0),
      e.currency ? (o(), s("span", z, r(" " + e.currency), 1)) : t("", !0),
      e.suffix ? (o(), s("span", M, r(e.suffix), 1)) : t("", !0)
    ]));
  }
});
export {
  S as default
};
//# sourceMappingURL=number.js.map
